var _filterOperatorMap,
    _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/constants.tsx";

import "core-js/modules/es.object.define-property.js";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as smApi from '@gmini/sm-api-sdk';
import { LessSign, EqualsSign, GreaterSign, NotEqualSign, LessThanOrEqualSign, GreaterThanOrEqualSign, ContainsSign, NotContainsSign } from '@gmini/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export var filterOperatorMap = (_filterOperatorMap = {}, _defineProperty(_filterOperatorMap, smApi.Filter.FilterCondition.Equals, 'Равно'), _defineProperty(_filterOperatorMap, smApi.Filter.FilterCondition.NotEquals, 'Не равно'), _defineProperty(_filterOperatorMap, smApi.Filter.FilterCondition.GreaterThan, 'Больше'), _defineProperty(_filterOperatorMap, smApi.Filter.FilterCondition.GreaterThanOrEqualsTo, 'Больше или равно'), _defineProperty(_filterOperatorMap, smApi.Filter.FilterCondition.LessThan, 'Меньше'), _defineProperty(_filterOperatorMap, smApi.Filter.FilterCondition.LessThanOrEqualsTo, 'Меньше или равно'), _defineProperty(_filterOperatorMap, smApi.Filter.FilterCondition.Contain, 'Содержит'), _defineProperty(_filterOperatorMap, smApi.Filter.FilterCondition.NotContain, 'Не содержит'), _filterOperatorMap);
export var filterOperatorList = [{
  label: filterOperatorMap.Equals,
  value: smApi.Filter.FilterCondition.Equals
}, {
  label: filterOperatorMap.NotEquals,
  value: smApi.Filter.FilterCondition.NotEquals
}, {
  label: filterOperatorMap.GreaterThan,
  value: smApi.Filter.FilterCondition.GreaterThan
}, {
  label: filterOperatorMap.GreaterThanOrEqualsTo,
  value: smApi.Filter.FilterCondition.GreaterThanOrEqualsTo
}, {
  label: filterOperatorMap.LessThan,
  value: smApi.Filter.FilterCondition.LessThan
}, {
  label: filterOperatorMap.LessThanOrEqualsTo,
  value: smApi.Filter.FilterCondition.LessThanOrEqualsTo
}, {
  label: filterOperatorMap.Contain,
  value: smApi.Filter.FilterCondition.Contain
}, {
  label: filterOperatorMap.NotContain,
  value: smApi.Filter.FilterCondition.NotContain
}];
export var getFilterOperatorIcon = function getFilterOperatorIcon(operator, hover) {
  var _iconsByOperator;

  var iconsByOperator = (_iconsByOperator = {}, _defineProperty(_iconsByOperator, smApi.Filter.FilterCondition.Equals, /*#__PURE__*/_jsx(EqualsSign, {})), _defineProperty(_iconsByOperator, smApi.Filter.FilterCondition.NotEquals, /*#__PURE__*/_jsx(NotEqualSign, {})), _defineProperty(_iconsByOperator, smApi.Filter.FilterCondition.GreaterThan, /*#__PURE__*/_jsx(GreaterSign, {})), _defineProperty(_iconsByOperator, smApi.Filter.FilterCondition.GreaterThanOrEqualsTo, /*#__PURE__*/_jsx(GreaterThanOrEqualSign, {})), _defineProperty(_iconsByOperator, smApi.Filter.FilterCondition.LessThan, /*#__PURE__*/_jsx(LessSign, {})), _defineProperty(_iconsByOperator, smApi.Filter.FilterCondition.LessThanOrEqualsTo, /*#__PURE__*/_jsx(LessThanOrEqualSign, {})), _defineProperty(_iconsByOperator, smApi.Filter.FilterCondition.Contain, /*#__PURE__*/_jsx(ContainsSign, {
    bgColor: hover ? '#F5F5F7' : '#fff'
  })), _defineProperty(_iconsByOperator, smApi.Filter.FilterCondition.NotContain, /*#__PURE__*/_jsx(NotContainsSign, {
    bgColor: hover ? '#F5F5F7' : '#fff'
  })), _iconsByOperator);
  return iconsByOperator[operator];
};
export var requiredErrorMessage = 'Укажите условия фильтрации';
var GLOBAL_FILTER_DATA_KEY = 'GLOBAL_FILTER_DATA_KEY';
export var getGlobalFilterDataKey = function getGlobalFilterDataKey() {
  return "".concat(GLOBAL_FILTER_DATA_KEY, "__").concat(window.location.pathname);
};
export var allModelsSourceItem = {
  id: 0,
  name: 'Все модели',
  type: 'ALL_MODELS'
};
export var noDependenciesErrorText = 'Необходимо добавить зависимости';
export var emptyFormCondition = {
  property: null,
  operator: null,
  value: ''
};